import axios from "axios";
import {getConfig} from '../helpers/config';

export class EventoService {
	baseAPIUrl = `${getConfig()?.url}eventi`;

    getAllDt = async (data) => {
        return await axios.post(`${this.baseAPIUrl}/allDt`, data).then(resp => resp.data);
    }
}